// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"195":"Popupv2","855":"Popup"}[chunkId] + "." + {"195":"70cbdee5","855":"70cbdee5"}[chunkId] + ".chunk.css";
};